/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { merge } from 'lodash';
import {
    ContentZonesService,
    ConfigsService as GeneralConfigService,
    LocaleService,
    UrlService,
} from '@sm360/widget-commons-core-services';
import { Translations as GeneralTranslations } from '@sm360/widget-commons-general';
import { Translations as FormTranslations } from '@sm360/widget-commons-forms';
import { ORGANIZATIONS } from '@sm360/widget-commons-vehicle';
import config from 'trade-in/config/index.js';

import en from 'trade-in/i18n/en.json';
import fr from 'trade-in/i18n/fr.json';

import InstantEstimate from 'trade-in/components/InstantEstimate/InstantEstimate.jsx';
import { NewTradeInProvider } from './NewTradeInContext';

class InstantEstimateProvider extends Component {
    constructor(props) {
        super(props);
        merge(en, FormTranslations.en, GeneralTranslations.en);
        merge(fr, FormTranslations.fr, GeneralTranslations.fr);

        LocaleService.setLocale(props.locale);
        LocaleService.loadTranslations({ en, fr });

        GeneralConfigService.setLocation(props.location);
        GeneralConfigService.setWebsiteId(props.websiteId);
        GeneralConfigService.setOrganizationId(this.props.organizationId);
        GeneralConfigService.setOrganizationUnitId(this.props.organizationUnitId);
        GeneralConfigService.setOrganizationUnitLocation(this.props.organizationUnitLocation);

        // Additional props for getting all dealer/website info
        GeneralConfigService.setOrganizationUnitName(props.organizationUnitName);
        GeneralConfigService.setOrganizationUnitPhone(props.organizationUnitPhone);
        GeneralConfigService.setScheduleMonday(props.schedule_monday);
        GeneralConfigService.setScheduleTuesday(props.schedule_tuesday);
        GeneralConfigService.setScheduleWednesday(props.schedule_wednesday);
        GeneralConfigService.setScheduleThursday(props.schedule_thursday);
        GeneralConfigService.setScheduleFriday(props.schedule_friday);
        GeneralConfigService.setScheduleSaturday(props.schedule_saturday);
        GeneralConfigService.setScheduleSunday(props.schedule_sunday);
        GeneralConfigService.setSalesDepartments(props.salesDepartments);
        GeneralConfigService.setWebsiteLogo(props.websiteLogo);
        GeneralConfigService.setWebsiteDomain(props.websiteDomain);
        GeneralConfigService.setWebsiteFacebookUrl(props.websiteFacebookPageUrl);
        GeneralConfigService.setWebsiteInstagramUrl(props.websiteInstagramClientId, props.websiteInstagramUserId);
        GeneralConfigService.setWebsiteTwitterUrl(props.websiteTwitterUrl);
        GeneralConfigService.setWebsiteYoutubeUrl(props.websiteYoutubeUrl);

        ContentZonesService.setImageServerBaseUrl(config.source.image);
        ContentZonesService.addContentZones(this.props.contentZones);

        this.state = {
            fieldsLocked: false,
            setFieldsLocked: this.setFieldsLocked,
            displayNewTradeIn:
                (UrlService.getUrlParameter('newTradeIn') && UrlService.getUrlParameter('newTradeIn') === 'true') ||
                this.props.organizationId === ORGANIZATIONS.DILAWRI,
        };
    }

    setFieldsLocked = (locked) => {
        this.setState({ fieldsLocked: locked });
    };

    render() {
        return (
            // TODO: newTradeIn - Remove NewTradeInProvider after new tradeIn deploy to the PROD
            <NewTradeInProvider value={this.state}>
                <InstantEstimate
                    parentElementId={this.props.parentElementId || this.props.location}
                    isShowroomV2Enabled={this.props.isShowroomV2Enabled}
                />
            </NewTradeInProvider>
        );
    }
}

InstantEstimateProvider.displayName = 'InstantEstimateProvider';

InstantEstimateProvider.propTypes = {
    locale: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    websiteId: PropTypes.number.isRequired,
    organizationUnitId: PropTypes.number.isRequired,
    organizationId: PropTypes.number.isRequired,
    organizationUnitLocation: PropTypes.string.isRequired,
    contentZones: PropTypes.objectOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                active: PropTypes.bool,
                group: PropTypes.string,
                id: PropTypes.number,
                location: PropTypes.string,
                position: PropTypes.number,
                type: PropTypes.string,
                value: PropTypes.string,
            })
        )
    ).isRequired,
    isShowroomV2Enabled: PropTypes.bool.isRequired,
};

export default InstantEstimateProvider;
